import { Globals } from "../CoreApp/Globals";

export function ReportToWebDriver(msg) {
  if (!Globals._accountInfo.ReportToWebDriver()) return;

  var ocn_title = document.getElementById("ocntitle");
  if (ocn_title == null) return;

  ocn_title.title = msg;
  ocn_title.sk = Globals._sessionKey;
}
